import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { HandWaveAnimation } from "Market/Components/Animation/HandWaveAnimation";
import { Stack, Typography } from "@mui/material";
import type { FC } from "react";

type Props = {
	name: string;
};

const marketSelectResource = Resources.base.market.shared.select;

export const Hello: FC<Props> = ({ name }) => {
	const { t } = useResource();

	return (
		<Stack direction="row" justifyContent="center" alignItems="center">
			<Typography variant="h1">
				{t(marketSelectResource.hello)}{" "}
				<span style={{ fontStyle: "italic" }}>{name}!</span>
			</Typography>
			<HandWaveAnimation>👋🏼</HandWaveAnimation>
		</Stack>
	);
};
